import { HttpClient } from '@angular/common/http';
import { Injectable, signal, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl; // Tu URL de Flask
  private _signedInSignal = signal<boolean>(!!localStorage.getItem('chroma-token'));

  login(credentials: any) {
    return this.http.post<any>(`${this.apiUrl}/login`, credentials).pipe(
      tap(response => {
        if (response && response.access_token) {
          localStorage.setItem('chroma-token', response.access_token);
          this._signedInSignal.set(true); // Actualizamos la señal
        }
      })
    );
  }

  // Método helper para saber si está logueado
  isLoggedIn(): boolean {
    return !!localStorage.getItem('chroma-token');
  }

  isSignedIn(): boolean {
    return this._signedInSignal();
  }

  // Método para cerrar sesión
  logout(): void {
    this._signedInSignal.set(false);
    localStorage.removeItem('chroma-token');
  }
}